export const INIT                = '@filter/INIT';
export const SET_CONDITION       = '@filter/SET_CONDITION';
export const ADD_GROUP           = '@filter/ADD_GROUP';
export const DEL_GROUP           = '@filter/DEL_GROUP';
export const SET_GROUP_CONDITION = '@filter/SET_GROUP_CONDITION';
export const ADD_FILTER          = '@filter/ADD_FILTER';
export const DEL_FILTER          = '@filter/DEL_FILTER';
export const EDIT_FILTER         = '@filter/EDIT_FILTER';
